/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'open-book-inverted': {
    width: 16,
    height: 16,
    viewBox: '0 0 429.623 429.623',
    data: '<path pid="0" d="M192.512 77.34c-48.64-25.088-105.984-25.088-154.624-.512L8.192 92.188C3.072 94.748 0 99.868 0 106.012v249.856c0 8.704 6.656 15.36 15.36 15.36 2.56 0 4.608-.512 7.168-1.536l29.696-15.36c39.424-20.48 86.528-20.48 125.952 0l21.504 11.264V80.924l-7.168-3.584zM421.888 92.188l-29.696-15.36c-48.64-24.576-105.984-24.576-154.112 0l-7.68 3.584v284.16l21.504-10.752c39.424-20.48 86.528-20.48 125.952 0l29.696 15.36c7.68 4.096 16.896 1.024 20.48-6.656 1.024-2.048 1.536-4.608 1.536-7.168V106.012c.512-6.144-2.56-11.264-7.68-13.824z"/>'
  }
})
